export type SessionExpirationState = "active" | "prompt" | "dismissed";

let state: SessionExpirationState = "active";
const listeners = new Set<() => void>();

function setState(nextState: SessionExpirationState): void {
  if (state === nextState) {
    return;
  }

  state = nextState;
  for (const listener of listeners) {
    listener();
  }
}

export function getSessionExpirationState(): SessionExpirationState {
  return state;
}

export function subscribeToSessionExpiration(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** 同一会话的并发失败只提示一次；用户取消后不再打断当前工作。 */
export function notifySessionExpired(): void {
  if (state === "active") {
    setState("prompt");
  }
}

export function dismissSessionExpiration(): void {
  setState("dismissed");
}

export function resetSessionExpiration(): void {
  setState("active");
}
